
import { Component, Vue } from "vue-property-decorator";
import Template from "@/views/system-management/template/index.vue";
import { Message } from "element-ui";
import {
  exportHqPackingList,
  uploadFactoryPackingList,
  uploadByOms,
  parentCode,
} from "@/api/factory-packing-list";
import { divide, multiply } from "@/utils/number";
import { matchPackingList, deleteByReUpload } from "@/api/purchase-order";

@Component({
  name: "UploadFactoryPackingList",
  components: { Template },
})
export default class extends Vue {
  private files: any[] = [];
  private drawer = false;

  private saveGSLoading = false;
  private saveJHLoading = false;
  // private props = {expandTrigger: 'hover', value: 'value', label: 'label'};
  private message: string[] = [];
  private id = "";
  private hqPackingListId = "";
  private codeOptions = [] as any;

  private disabledJCBG = false;

  private payload = {
    packingModel: "CTN",
    packingSelfCode: "",
    lengthUnit: "centimeter",
    weightUnit: "kg",
    customerCode: "",
    factoryName: "",
    requestParam: "",
  };
  private dataHeader: TableHeadler[] = [];

  private hqPackingList: FactoryPackingList = new FactoryPackingList();

  private factoryData: any[] = [];
  private code = "" as any;
  private parentcode = "" as any;
  private factoryDataMerge: any[] = [];

  private importantMessage = "以上选择的列内容不能为空";
  private rulesItem = [
    "SN",
    "型号",
    "产品总数量",
    "主包装件数",
    "长宽高毛净重",
    "采购订单号",
    "包装类型",
    "自编码",
    "箱号",
  ];

  private customsPackingIndex: CustomsPackingIndex;
  private secondPackingIndex: SecondPackingIndex;
  private productInfoIndex: ProductIndex;

  private isReUpload = false;

  private packingOptions = [
    { value: "CTN", label: "箱" },
    { value: "PLT", label: "托" },
  ];
  private lengthUnitOptions = [
    { value: "meter", label: "米" },
    { value: "centimeter", label: "厘米" },
  ];
  private weightUnitOptions = [
    { value: "kg", label: "千克" },
    { value: "g", label: "克" },
  ];
  private options = [
    {
      value: "receipt",
      label: "单据项",
      children: [
        {
          value: "sn",
          label: "SN",
        },
        {
          value: "purchaseOrderNumber",
          label: "采购订单号",
        },
        {
          value: "settlementUnitPrice",
          label: "结算单价",
        },
        {
          value: "remark",
          label: "备注",
        },
        {
          value: "tagInventory",
          label: "是否为库存",
        },
        {
          value: "containerNumber",
          label: "箱封号",
        }
      ],
    },
    {
      value: "customsPacking",
      label: "主包装",
      children: [
        {
          value: "customsLength",
          label: "长",
        },
        {
          value: "customsWidth",
          label: "宽",
        },
        {
          value: "customsHeight",
          label: "高",
        },
        {
          value: "customsNetWeight",
          label: "净重",
        },
        {
          value: "customsGrossWeight",
          label: "毛重",
        },
        {
          value: "customsQuantity",
          label: "数量",
        },
        {
          value: "packingNumber",
          label: "箱号",
        },
        {
          value: "customsQty",
          label: "装箱数量",
        },
        {
          value: "customsVolume",
          label: "尺寸(长*宽*高)",
        },
        {
          value: "typeCode",
          label: "包装模式",
        },
        {
          value: "selfCode",
          label: "自编码",
        },
      ],
    },
    {
      value: "secondaryPacking",
      label: "次包装",
      children: [
        {
          value: "secondaryLength",
          label: "长",
        },
        {
          value: "secondaryWidth",
          label: "宽",
        },
        {
          value: "secondaryHeight",
          label: "高",
        },
        {
          value: "secondaryNetWeight",
          label: "净重",
        },
        {
          value: "secondaryGrossWeight",
          label: "毛重",
        },
        {
          value: "secondaryQuantity",
          label: "数量",
        },
        {
          value: "secondaryPackingNumber",
          label: "箱号",
        },
        {
          value: "secondaryQty",
          label: "装箱数量",
        },
        {
          value: "secondaryVolume",
          label: "尺寸(长*宽*高)",
        },
      ],
    },
    {
      value: "product",
      label: "产品",
      children: [
        {
          value: "guestModel",
          label: "客人型号",
        },
        {
          value: "hqNumber",
          label: "HQ号码",
        },
        {
          value: "jrNumber",
          label: "JR号码",
        },
        {
          value: "oeNumber",
          label: "OE号码",
        },
        {
          value: "refNumber",
          label: "REF",
        },
        {
          value: "hqTransactionNumber",
          label: "HQ交易号码",
        },
        {
          value: "totalNumberPcs",
          label: "总数量",
        },
        {
          value: "netWeight",
          label: "单支净重",
        },
        {
          value: "totalNetWeight",
          label: "总净重",
        },
      ],
    },
  ];

  created() {
    if (this.$route.query.id) {
      this.id = (this.$route.query.id as string) || "";
      this.payload.requestParam = (this.$route.query.id as string) || "";
      this.disabledJCBG = true;
    }
    if (this.$route.query.code) {
      // 有code为重新上传 没有为第一次上传
      this.isReUpload = true;
      this.payload.requestParam = (this.$route.query.code as string) || "";
      this.code = (this.$route.query.code as string) || "";
      this.disabledJCBG = true;
    }
    if (this.$route.query.parentCode) {
      this.payload.requestParam =
        (this.$route.query.parentCode as string) || "";
      this.parentcode = (this.$route.query.parentCode as string) || "";
      this.disabledJCBG = true;
    }
    this.drawer = false;
    this.parentCode();
  }

  private multipleSelection: any[] = [];

  private cellHandleclick(row, column, cell, event) {
    if (column.label === this.dataHeader[0].originalLabel) {
      //执行逻辑
      console.log(1111);
      // 从已选中数据中 判断当前点击的是否被选中
      const selected = this.multipleSelection.some(
        (item) => item.co0 === row.co0
      ); // 是取消选择还是选中
      if (!selected) {
        // 不包含   代表选择
        // 选择后添加到已选中数组中
        this.multipleSelection.push(row);
        (this.$refs.multipleTable as any).toggleRowSelection(row, true);
      } else {
        // 取消选择
        let finalArr = this.multipleSelection.filter((item) => {
          return item.co0 !== row.co0;
        });
        this.multipleSelection = finalArr; // 取消后剩余选中的

        (this.$refs.multipleTable as any).toggleRowSelection(row, false);
      }
      console.log("更改选择后", this.multipleSelection);
    }
  }

  private rowStyle({ row, column }) {
    if (column.label === this.dataHeader[0].originalLabel) {
      const arr = this.multipleSelection;
      for (let i = 0; i < arr.length; i++) {
        if (row.co0 === arr[i].co0) {
          return "rowStyle";
        }
      }
    }
  }

  // 表格合并单元格
  private arraySpanMethod({ row, column, rowIndex, columnIndex }) {
    if (this.dataHeader[columnIndex].whetherMerge) {
      if (this.factoryDataMerge[rowIndex][columnIndex].mergeNumber > 1) {
        return {
          rowspan: this.factoryDataMerge[rowIndex][columnIndex].mergeNumber,
          colspan: 1,
        };
        // 隐藏已经被合并的单元格
      } else if (
        this.factoryDataMerge[rowIndex][columnIndex].name !==
        "co" + columnIndex
      ) {
        return {
          rowspan: 0,
          colspan: 0,
        };
      } else {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
    }
    //其余的不合并
    return {
      rowspan: 1,
      colspan: 1,
    };
  }

  private addFile(file: any) {
    if (file.size / 1024 / 1024 >= 10) {
      Message({
        message: "上传的文件大小不能超过10M!",
        type: "error",
        duration: 2 * 1000,
      });
      return;
    }
    this.files.push(file);
  }

  private async handleUpload() {
    if (this.files.length == 0) {
      return;
    }
    this.dataHeader = [];
    this.factoryData = [];
    this.factoryDataMerge = [];
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    await uploadFactoryPackingList(formData).then((data: any) => {
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      this.dataHeader = data.title;
      this.factoryData = data.table;
      this.factoryDataMerge = data.merge;
    });
    this.files = [];
  }

  private mergeCustomsPackingVolume = false;
  private mergeSecondPackingVolume = false;

  private handleCommand(val) {
    console.log(val);
  }

  private async buildHqPackingList() {
    this.saveGSLoading = true;
    if (!this.payload.requestParam) {
      Message.error({
        message: "请选择进仓单号/报关计划ID",
        duration: 2000,
      });
      this.saveGSLoading = false;
      return;
    }
    // 初始化数据
    this.hqPackingList.packingLists = [];
    this.customsPackingIndex = new CustomsPackingIndex();
    this.secondPackingIndex = new SecondPackingIndex();
    this.productInfoIndex = new ProductIndex();
    const realTableColumn: TableHeadler[] = this.dataHeader.filter(
      (d) => d.titleGroup
    );
    this.message = [];
    let hqOrJrMatch = null;

    // 判断是否选择了重复的列
    const titles = realTableColumn
        .filter(item => item.titleGroup.length > 0)
        .map(item => item.titleGroup[1]);
    const repeat = titles.filter((item, index) => titles.indexOf(item) !== index);
    if (repeat.length > 0) {
      const repeatName = repeat.map(item => {
        const a = this.options.filter(i => i.children.some(option => option.value === item))[0];
        const b = a.children.filter(i => i.value === item)[0];
        return "[" + a.label + "/" + b.label + "]";
      })
      Message.error({
        message: `选择了相同的列:` + repeatName.join(", "),
        duration: 2000,
      });
      this.saveGSLoading = false;
      return
    }
    // 判断选择了HQ号码还是JR号码放到productHqNumber字段上
    const hasHqNumber = realTableColumn.some(item => item.titleGroup[1] === "hqNumber");
    const hasJrNumber = realTableColumn.some(item => item.titleGroup[1] === "jrNumber");
    if (hasHqNumber && hasJrNumber) {
      Message.error({
        message: `不能同时选择【HQ号码】和【JR号码】`,
        duration: 2000,
      });
      this.saveGSLoading = false;
      return
    }
    if (hasHqNumber && !hasJrNumber) {
      hqOrJrMatch = "hq";
    }
    if (!hasHqNumber && hasJrNumber) {
      hqOrJrMatch = "jr";
    }

    let errorForNum = false; // 判断主包装的数量是否为空
    if(realTableColumn.findIndex(e => e.titleGroup[1] === "totalNumberPcs") !== -1) {
      let numProp = realTableColumn.find(e => e.titleGroup[1] === "totalNumberPcs").prop // 获取数据的列名
      for(let i = 0; i < this.factoryData.length; i++) {
        if(!this.factoryData[i][numProp]) {
          Message.error({
            message: `第${i+1}行产品的数量不能为空！`,
            duration: 2000,
          });
          this.saveGSLoading = false;
          return
        }
      }
      // this.factoryData.map(item => {
      //   if(!item[numProp]) { // 判断是否有值
      //     errorForNum = true
      //   }
      // })
      // if(errorForNum) {
      //   Message.error({
      //     message: "产品的数量不能为空！",
      //     duration: 2000,
      //   });
      //   this.saveGSLoading = false;
      //   return
      // }
    }
    if(this.payload.requestParam.includes('BI') || this.payload.requestParam.includes('JBI')) { // 如果号码之中包含BI或者JBI 那么表头就不能选择是否为库存
      let errorForInventory = false
      for(let i = 0; i < realTableColumn.length; i++) {
        if(realTableColumn[i].titleGroup[1] === "tagInventory") {
          Message.error({
            message: `第${i+1}行报关计划无法选择库存！`,
            duration: 2000,
          });
          this.saveGSLoading = false;
          return
        }
      }
      // realTableColumn.map(item => {
      //   if(item.titleGroup[1] === "tagInventory") { // 判断表头是否含有 是否为库存 的header
      //     errorForInventory = true
      //   }
      // })
      // if(errorForInventory) {
      //   Message.error({
      //     message: "报关计划无法选择库存！",
      //     duration: 2000,
      //   });
      //   this.saveGSLoading = false;
      //   return
      // }
    }
    // 拿到主包装的列，次包装，产品的列号
    for (let i = 0; i < realTableColumn.length; i++) {
      this.setPackingIndex(realTableColumn[i]);
    }
    //校验必选项是否已经选择，给出提示
    this.checkNecessaryData();
    //生成主次包装合并单元格
    let customStartIndex = 0;
    let secondaryStartIndex = 0;
    let customsPackingQtyStartIndex = 0;
    let customsPackingNetWeightStartIndex = 0;
    let customerRowKey = 0;
    let secondaryRowKey = 0;
    let customsPackingQtyRowKey = 0; //主包装装箱数量合并关键字
    let customsPackingNetWeightRowKey = 0; //主包装净重合并关键字
    // 主包装合并单元格
    let customsRowMergeIndex = this.getCustomsPackingIndex();
    if (this.mergeCustomsPackingVolume) {
      for(let i = 0; i < this.factoryDataMerge.length;) {
        const regex = /^\d+(\.\d+)?\*\d+(\.\d+)?\*\d+(\.\d+)?$/;
        const volume = this.factoryDataMerge[i].filter(x => x.name === "co" + customsRowMergeIndex)[0].value;
        if (volume != null && !regex.test(volume)) {
          Message.error({
            message: `第${i+1}行主包装尺寸格式错误！`,
            duration: 2000,
          });
          this.saveGSLoading = false;
          return
        }
        i += this.factoryDataMerge[i].filter(x => x.name === "co" + customsRowMergeIndex)[0].mergeNumber;
      }
    }
    // 主包装合并单元格为空则报错
    if (customsRowMergeIndex === -1) {
      Message.error({
        message: "请选择主包装体积参数",
        duration: 2000,
      });
      this.saveGSLoading = false;
      return;
    }

    // 判断次包装是否为12*12*12
    let secondPackingVolume = this.getSecondPackingVolume();
    if (this.mergeSecondPackingVolume) {
      for(let i = 0; i < this.factoryDataMerge.length;) {
        const regex = /^\d+(\.\d+)?\*\d+(\.\d+)?\*\d+(\.\d+)?$/;
        const volume = this.factoryDataMerge[i].filter(x => x.name === "co" + secondPackingVolume)[0].value;
        if (volume != null && !regex.test(volume)) {
          Message.error({
            message: `第${i+1}行次包装尺寸格式错误！`,
            duration: 2000,
          });
          this.saveGSLoading = false;
          return
        }
        i += this.factoryDataMerge[i].filter(x => x.name === "co" + secondPackingVolume)[0].mergeNumber;
      }
    }

    const secondCartonNumber = this.getSecondCartonNumber();
    // 次包装合并单元格
    let secondPackingRowMergeIndex = this.getSecondPackingIndex();
    // 主包装装箱数量合并单元格
    let customsPackingQtyRowMergeIndex = this.getCustomsPackingQtyIndex();
    // 主包装净重合并单元格
    let customsPackingNetWeightMergeIndex =
      this.getCustomsPackingNetWeightIndex();
    let packingList: PackingList[] = [];
    // 拿到每一行主包装合并的内容
    for (let i = 0; i < this.factoryDataMerge.length; i++) {
      //合并主包装
      if (customStartIndex < this.factoryDataMerge.length) {
        let customsMergeNumber =
          this.factoryDataMerge[customStartIndex][customsRowMergeIndex]
            .mergeNumber;
        // endIndex = startIndex + this.factoryDataMerge[startIndex][customsRowMergeIndex].mergeNumber;
        //得到主包装的key
        if (i === customStartIndex) {
          customerRowKey++;
          customStartIndex = customStartIndex + customsMergeNumber;
        }
      }
      //合并次包装
      if (secondaryStartIndex < this.factoryDataMerge.length) {
        let secondPackingMergeNumber =
          this.factoryDataMerge[secondaryStartIndex][secondPackingRowMergeIndex]
            .mergeNumber;
        if (i === secondaryStartIndex) {
          secondaryRowKey++;
          secondaryStartIndex = secondaryStartIndex + secondPackingMergeNumber;
        }
      }
      //合并主包装装箱数量
      if (customsPackingQtyStartIndex < this.factoryDataMerge.length) {
        let customsPackingQtyMergeNumber =
          this.factoryDataMerge[customsPackingQtyStartIndex][
            customsPackingQtyRowMergeIndex
          ].mergeNumber;
        if (i === customsPackingQtyStartIndex) {
          customsPackingQtyRowKey++;
          customsPackingQtyStartIndex =
            customsPackingQtyStartIndex + customsPackingQtyMergeNumber;
        }
      }
      //合并主包装净重
      if (customsPackingNetWeightStartIndex < this.factoryDataMerge.length) {
        let customsPackingNetWeightMergeNumber =
          this.factoryDataMerge[customsPackingNetWeightStartIndex][
            customsPackingNetWeightMergeIndex
          ].mergeNumber;
        if (i === customsPackingNetWeightStartIndex) {
          customsPackingNetWeightRowKey++;
          customsPackingNetWeightStartIndex =
            customsPackingNetWeightStartIndex +
            customsPackingNetWeightMergeNumber;
        }
      }

      let packing = new PackingList();
      //构建主包装数据
      if (this.mergeCustomsPackingVolume) {
        let volume = ["0", "0", "0"];
        //如果是12*12*12的则将他们分开
        if (
          this.getFactoryData(i, this.customsPackingIndex.customsVolumeIndex)
        ) {
          volume = this.getFactoryData(
            i,
            this.customsPackingIndex.customsVolumeIndex
          ).split("*");
        }
        //得到真实的体积数据，判断单位
        packing.buildWeightAndVolume(
          this.getRealVolumeUnitData(volume[0]),
          this.getRealVolumeUnitData(volume[1]),
          this.getRealVolumeUnitData(volume[2]),
          this.getRealWeightUnitData(
            this.getFactoryData(i, this.customsPackingIndex.netWeightIndex)
          ),
          this.getRealWeightUnitData(
            this.getFactoryData(i, this.customsPackingIndex.grossWeightIndex)
          )
        );
      } else {
        //正常数据
        packing.buildWeightAndVolume(
          this.getRealVolumeUnitData(
            this.getFactoryData(i, this.customsPackingIndex.lengthIndex)
          ),
          this.getRealVolumeUnitData(
            this.getFactoryData(i, this.customsPackingIndex.widthIndex)
          ),
          this.getRealVolumeUnitData(
            this.getFactoryData(i, this.customsPackingIndex.heightIndex)
          ),
          this.getRealWeightUnitData(
            this.getFactoryData(i, this.customsPackingIndex.netWeightIndex)
          ),
          this.getRealWeightUnitData(
            this.getFactoryData(i, this.customsPackingIndex.grossWeightIndex)
          )
        );
      }
      // 标记为箱,添加自编码
      packing.buildCustomsPacking(
        this.getFactoryData(i, this.customsPackingIndex.typeCodeIndex),
        this.getFactoryData(i, this.customsPackingIndex.selfCodeIndex),
        this.getFactoryData(i, this.customsPackingIndex.serialNumberIndex),
        this.getFactoryData(i, this.customsPackingIndex.customsQuantity),
        this.getFactoryData(i, this.customsPackingIndex.customsQtyIndex),
        customerRowKey,
        customsPackingQtyRowKey,
        customsPackingNetWeightRowKey,
        this.getFactoryData(i, this.customsPackingIndex.tagInventory)
      );
      //构建次包装数据，如果次包装数量没有则为1
      packing.buildSecondaryPacking(
          secondCartonNumber === 0
          ? "1"
          : this.getFactoryData(i, secondCartonNumber),
        secondaryRowKey,
        this.getFactoryData(i, this.secondPackingIndex.serialNumberIndex),
        this.getFactoryData(i, this.secondPackingIndex.secondaryQty)
      );
      //构建产品重量体积数据得到真实的体积数据，判断单位
      // 如果次包装是12*12*12就给它分开
      if (this.mergeSecondPackingVolume) {
        let volume = ["0", "0", "0"];
        if (this.getFactoryData(i, secondPackingVolume)) {
          volume = this.getFactoryData(i, secondPackingVolume).split("*");
        }
        //得到真实的体积数据，判断单位
        packing.buildSecondaryPackingWeightAndVolume(
          this.getRealVolumeUnitData(volume[0]),
          this.getRealVolumeUnitData(volume[1]),
          this.getRealVolumeUnitData(volume[2]),
          this.getRealWeightUnitData(
            this.getFactoryData(i, this.secondPackingIndex.netWeightIndex)
          ),
          this.getRealWeightUnitData(
            this.getFactoryData(i, this.secondPackingIndex.grossWeightIndex)
          )
        );
      } else {
        packing.buildSecondaryPackingWeightAndVolume(
          this.getRealVolumeUnitData(
            this.getFactoryData(i, this.secondPackingIndex.lengthIndex)
          ),
          this.getRealVolumeUnitData(
            this.getFactoryData(i, this.secondPackingIndex.widthIndex)
          ),
          this.getRealVolumeUnitData(
            this.getFactoryData(i, this.secondPackingIndex.heightIndex)
          ),
          this.getRealWeightUnitData(
            this.getFactoryData(i, this.secondPackingIndex.netWeightIndex)
          ),
          this.getRealWeightUnitData(
            this.getFactoryData(i, this.secondPackingIndex.grossWeightIndex)
          )
        );
      }

      //构建产品数据
      packing.buildProductInfoWeight(
        this.getRealWeightUnitData(
          this.getFactoryData(i, this.productInfoIndex.netWeightIndex)
        ),
        this.getRealWeightUnitData(
          this.getFactoryData(i, this.productInfoIndex.totalNetWeightIndex)
        )
      );
      try {
        let productHqNumber = null;
        if (hqOrJrMatch === "hq") {
          productHqNumber = this.getFactoryData(i, this.productInfoIndex.hqNumberIndex);
        }
        if (hqOrJrMatch === "jr") {
          productHqNumber = this.getFactoryData(i, this.productInfoIndex.jrNumberIndex);
        }
        packing.buildProductInfo(
            this.getFactoryData(i, this.productInfoIndex.snIndex),
            this.getFactoryData(i, this.productInfoIndex.guestModelIndex),
            productHqNumber,
            this.getFactoryData(i, this.productInfoIndex.oeNumberIndex),
            this.getFactoryData(i, this.productInfoIndex.refNumberIndex),
            this.getFactoryData(i, this.productInfoIndex.hqTransactionNumberIndex),
            this.getFactoryData(i, this.productInfoIndex.totalNumberPcsIndex),
            this.getFactoryData(i, this.productInfoIndex.purchaseOrderNumberIndex),
            this.extractNumberFromCurrency(this.getFactoryData(i, this.productInfoIndex.settlementUnitPriceIndex)),
            this.getFactoryData(i, this.productInfoIndex.remarkIndex),
            this.getFactoryData(i, this.productInfoIndex.containerNumberIndex),
            hqOrJrMatch,
        );
      } catch (error) {
        this.$message.error(error.message);
        this.saveGSLoading = false;
        return;
      }
      packingList.push(packing);
    }
    // 构建装箱单信息
    this.hqPackingList.packingLists = packingList;
    this.hqPackingList.factoryName = this.payload.factoryName;
    this.hqPackingList.packingType = this.payload.packingModel;
    this.hqPackingList.parentCode = this.payload.requestParam;

    // 有必填项未填，给出提示
    if (this.message.length > 0) {
      this.saveGSLoading = false;
      this.$confirm(this.message.toString(), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          this.saveGSLoading = true;
          exportHqPackingList(this.hqPackingList)
            .then((res) => {
              console.log(res);
              // this.$message({
              //   type: "success",
              //   message: "格式校验!"
              // });
              this.uploadByOms(res);
              this.saveGSLoading = false;
            })
            .catch((err) => {
              console.log(err);
              this.saveGSLoading = false;
            })
            .finally(() => this.saveGSLoading = false);
        })
        .catch(() => {
          this.saveGSLoading = false;
          this.$message({
            type: "info",
            message: "取消格式校验",
          });
        });
    } else {
      // exportHqPackingList(this.hqPackingList);
      exportHqPackingList(this.hqPackingList).then((res) => {
        console.log(res);
        this.uploadByOms(res);
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.saveGSLoading = false;
      });
    }
  }

  private async parentCode(query = "") {
    const res = await parentCode({
      keyword: query,
    });
    this.codeOptions = res;
  }

  private async uploadByOms(name) {
    // 重新上传 requestParam id
    // 普通上传 requestParam this.payload.requestParam
    let sourceType = "";
    if (this.payload.requestParam) {
      sourceType = this.codeOptions.find(
        (item) => item.code === this.payload.requestParam
      ).type;
    }
    await uploadByOms({
      fileName: name,
      requestParam: this.id
        ? this.id
        : this.parentcode || this.$route.query.parentCode,
      type: this.id ? "UPDATE" : "CREATE",
      sourceType: this.id ? "" : sourceType,
    }).then(async (res: any) => {
      this.hqPackingListId = res;
      if (this.id) {
        await deleteByReUpload(this.id);
      }
    });
  }

  private async deliveryVerification() {
    try {
      this.saveJHLoading = true;
      // 匹配
      await matchPackingList({
        packingListId: this.hqPackingListId,
      });
      if (this.$route.query.code) {
        this.$router.push(
            `/deliveryVerification?hqPackingListId=${this.hqPackingListId}&hqPackingListCode=${this.$route.query.code}&isReUpload=${this.isReUpload}`
        );
        this.saveJHLoading = false;
      } else {
        this.$router.push(
            `/deliveryVerification?hqPackingListId=${this.hqPackingListId}&isReUpload=${this.isReUpload}`
        );
        this.saveJHLoading = false;
      }
    } finally {
      this.saveJHLoading = false;
    }
  }

  private getPackingType(index) {
    this.multipleSelection[index].co1;
  }

  //得到每一行对应的值
  private getFactoryData(row: number, index: number) {
    switch (index) {
      case 0:
        return this.factoryData[row].co0;
      case 1:
        return this.factoryData[row].co1;
      case 2:
        return this.factoryData[row].co2;
      case 3:
        return this.factoryData[row].co3;
      case 4:
        return this.factoryData[row].co4;
      case 5:
        return this.factoryData[row].co5;
      case 6:
        return this.factoryData[row].co6;
      case 7:
        return this.factoryData[row].co7;
      case 8:
        return this.factoryData[row].co8;
      case 9:
        return this.factoryData[row].co9;
      case 10:
        return this.factoryData[row].co10;
      case 11:
        return this.factoryData[row].co11;
      case 12:
        return this.factoryData[row].co12;
      case 13:
        return this.factoryData[row].co13;
      case 14:
        return this.factoryData[row].co14;
      case 15:
        return this.factoryData[row].co15;
      case 16:
        return this.factoryData[row].co16;
      case 17:
        return this.factoryData[row].co17;
      case 18:
        return this.factoryData[row].co18;
      case 19:
        return this.factoryData[row].co19;
      case 20:
        return this.factoryData[row].co20;
      case 21:
        return this.factoryData[row].co21;
      case 22:
        return this.factoryData[row].co22;
      case 23:
        return this.factoryData[row].co23;
      case 24:
        return this.factoryData[row].co24;
      case 25:
        return this.factoryData[row].co25;
      case 26:
        return this.factoryData[row].co26;
      case 27:
        return this.factoryData[row].co27;
      case 28:
        return this.factoryData[row].co28;
      case 29:
        return this.factoryData[row].co29;
      case 30:
        return this.factoryData[row].co30;
      case 31:
        return this.factoryData[row].co31;
      case 32:
        return this.factoryData[row].co32;
      case 33:
        return this.factoryData[row].co33;
      case 34:
        return this.factoryData[row].co34;
      case 35:
        return this.factoryData[row].co35;
      case 36:
        return this.factoryData[row].co36;
      case 37:
        return this.factoryData[row].co37;
      case 38:
        return this.factoryData[row].co38;
      case 39:
        return this.factoryData[row].co39;
      case 40:
        return this.factoryData[row].co40;
    }
  }

  // 判断主包装长宽高合并单元格
  private getCustomsPackingIndex() {
    if (this.customsPackingIndex.customsVolumeIndex !== undefined) {
      this.mergeCustomsPackingVolume = true;
      return this.customsPackingIndex.customsVolumeIndex;
    } else if (
      this.customsPackingIndex.lengthIndex !== undefined &&
      this.customsPackingIndex.widthIndex !== undefined &&
      this.customsPackingIndex.heightIndex !== undefined
    ) {
      this.mergeCustomsPackingVolume = false;
      return this.customsPackingIndex.lengthIndex;
    }
    if (this.customsPackingIndex.lengthIndex === undefined) {
      this.message.push("<br>未找到<b>主包装长</b>数据");
    } else if (this.customsPackingIndex.widthIndex === undefined) {
      this.message.push("<br>未找到<b>主包装宽</b>数据");
    } else if (this.customsPackingIndex.heightIndex === undefined) {
      this.message.push("<br>未找到<b>主包装高</b>数据");
    }
    this.mergeCustomsPackingVolume = false;
    return -1;
  }

  private getSecondPackingVolume() {
    if (this.secondPackingIndex.secondaryVolumeIndex !== undefined) {
      this.mergeSecondPackingVolume = true;
      return this.secondPackingIndex.secondaryVolumeIndex;
    } else if (this.secondPackingIndex.lengthIndex !== undefined) {
      this.mergeSecondPackingVolume = false;
      return this.secondPackingIndex.lengthIndex;
    }
    this.mergeSecondPackingVolume = false;
    return 0;
  }

  // 获取次包装合并用
  private getSecondPackingIndex() {
    if (this.secondPackingIndex.cartonNumberIndex !== undefined) {
      return this.secondPackingIndex.cartonNumberIndex;
    } else {
      if (this.productInfoIndex.snIndex !== undefined) {
        return this.productInfoIndex.snIndex;
      }
      return 0;
    }
  }

  // 获取次包装数量列
  private getSecondCartonNumber() {
    if (this.secondPackingIndex.cartonNumberIndex !== undefined) {
      return this.secondPackingIndex.cartonNumberIndex;
    } else {
      this.message.push("<br>未找到<b>次包装数量列,默认为1</b>");
      return 0;
    }
  }

  // 判断主包装装箱数量是否存在
  private getCustomsPackingQtyIndex() {
    if (this.customsPackingIndex.customsQtyIndex !== undefined) {
      return this.customsPackingIndex.customsQtyIndex;
    } else {
      this.message.push("<br>未找到<b>主包装装箱数量列</b>");
      return this.getCustomsPackingIndex();
    }
  }

  // 判断主包装净重是否存在
  private getCustomsPackingNetWeightIndex() {
    if (this.customsPackingIndex.netWeightIndex !== undefined) {
      return this.customsPackingIndex.netWeightIndex;
    }
    // else if (this.customsPackingIndex.grossWeightIndex !== undefined){
    //   return this.customsPackingIndex.grossWeightIndex;
    // }
    else {
      this.message.push("<br>未找到<b>主包净重列</b>");
      return this.getCustomsPackingIndex();
    }
  }

  //设置主包装的列
  private setPackingIndex(header: TableHeadler) {
    switch (header.titleGroup[1]) {
      // 给主包装列赋值
      case "typeCode":
        this.customsPackingIndex.typeCodeIndex = this.getRealRow(header.prop);
        break;
      case "selfCode":
        this.customsPackingIndex.selfCodeIndex = this.getRealRow(header.prop);
        break;
      case "customsLength":
        this.customsPackingIndex.lengthIndex = this.getRealRow(header.prop);
        break;
      case "customsWidth":
        this.customsPackingIndex.widthIndex = this.getRealRow(header.prop);
        break;
      case "customsHeight":
        this.customsPackingIndex.heightIndex = this.getRealRow(header.prop);
        break;
      case "customsGrossWeight":
        this.customsPackingIndex.grossWeightIndex = this.getRealRow(
          header.prop
        );
        break;
      case "customsNetWeight":
        this.customsPackingIndex.netWeightIndex = this.getRealRow(header.prop);
        break;
      case "customsVolume":
        this.customsPackingIndex.customsVolumeIndex = this.getRealRow(
          header.prop
        );
        break;
      case "packingNumber":
        this.customsPackingIndex.serialNumberIndex = this.getRealRow(
          header.prop
        );
        break;
      case "customsQty":
        this.customsPackingIndex.customsQtyIndex = this.getRealRow(header.prop);
        break;
      case "customsQuantity":
        this.customsPackingIndex.customsQuantity = this.getRealRow(header.prop);
        break;
      case "tagInventory":
        this.customsPackingIndex.tagInventory = this.getRealRow(header.prop);
        break;
      // 给次包装赋值
      case "secondaryLength":
        this.secondPackingIndex.lengthIndex = this.getRealRow(header.prop);
        break;
      case "secondaryWidth":
        this.secondPackingIndex.widthIndex = this.getRealRow(header.prop);
        break;
      case "secondaryHeight":
        this.secondPackingIndex.heightIndex = this.getRealRow(header.prop);
        break;
      case "secondaryNetWeight":
        this.secondPackingIndex.netWeightIndex = this.getRealRow(header.prop);
        break;
      case "secondaryGrossWeight":
        this.secondPackingIndex.grossWeightIndex = this.getRealRow(header.prop);
        break;
      case "secondaryQuantity":
        this.secondPackingIndex.cartonNumberIndex = this.getRealRow(
          header.prop
        );
        break;
      case "secondaryPackingNumber":
        this.secondPackingIndex.serialNumberIndex = this.getRealRow(
          header.prop
        );
        break;
      case "secondaryVolume":
        this.secondPackingIndex.secondaryVolumeIndex = this.getRealRow(
          header.prop
        );
        break;
      case "secondaryQty":
        this.secondPackingIndex.secondaryQty = this.getRealRow(header.prop);
        break;
      // 给产品赋值
      case "sn":
        this.productInfoIndex.snIndex = this.getRealRow(header.prop);
        break;
      case "remark":
        this.productInfoIndex.remarkIndex = this.getRealRow(header.prop);
        break;
      case "containerNumber":
        this.productInfoIndex.containerNumberIndex = this.getRealRow(header.prop);
        break;
      case "guestModel":
        this.productInfoIndex.guestModelIndex = this.getRealRow(header.prop);
        break;
      case "hqNumber":
        this.productInfoIndex.hqNumberIndex = this.getRealRow(header.prop);
        break;
      case "jrNumber":
        this.productInfoIndex.jrNumberIndex = this.getRealRow(header.prop);
        break;
      case "oeNumber":
        this.productInfoIndex.oeNumberIndex = this.getRealRow(header.prop);
        break;
      case "refNumber":
        this.productInfoIndex.refNumberIndex = this.getRealRow(header.prop);
        break;
      case "hqTransactionNumber":
        this.productInfoIndex.hqTransactionNumberIndex = this.getRealRow(header.prop);
        break;
      case "totalNumberPcs":
        this.productInfoIndex.totalNumberPcsIndex = this.getRealRow(
          header.prop
        );
        break;
      case "netWeight":
        this.productInfoIndex.netWeightIndex = this.getRealRow(header.prop);
        break;
      case "totalNetWeight":
        this.productInfoIndex.totalNetWeightIndex = this.getRealRow(
          header.prop
        );
        break;
      case "purchaseOrderNumber":
        this.productInfoIndex.purchaseOrderNumberIndex = this.getRealRow(
          header.prop
        );
        break;
      case "settlementUnitPrice":
        this.productInfoIndex.settlementUnitPriceIndex = this.getRealRow(
          header.prop
        );
        break;
      default:
        break;
    }
  }

  /**
   * 从货币值中提取数字
   * @param value
   * @private
   */
  private extractNumberFromCurrency(value: any): string {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    // 将值转换为字符串
    let strValue = String(value);
    // 使用正则表达式匹配数字（包括小数点）
    // 这个正则表达式会匹配: 符号、整数、小数点、小数部分
    const currencyRegex = /[-+]?(?:\d+\.?\d*|\.\d+)(?:[eE][-+]?\d+)?/g;
    const matches = strValue.match(currencyRegex);

    if (matches && matches.length > 0) {
      if (matches.length > 1) {
        throw new Error("请检查并输入正确的【金额】。在单个价格中匹配到多个金额。excel中的异常价格【" + value + "】");
      }
      // 返回第一个匹配的数字
      return matches[0];
    }
    // 如果没有匹配到数字
    throw new Error("价格解析失败,请输入正确的【金额】并指定【价格所在单元格】为货币符号类型。excel中的异常价格【" + value + "】");
  }

  private checkNecessaryData() {
    if (this.productInfoIndex.purchaseOrderNumberIndex === undefined) {
      this.message.push("<br>未找到<b>采购订单号</b>数据");
    }
    if (
      !(
        this.productInfoIndex.guestModelIndex !== undefined ||
        this.productInfoIndex.hqNumberIndex !== undefined ||
        this.productInfoIndex.jrNumberIndex !== undefined ||
        this.productInfoIndex.oeNumberIndex != undefined ||
        this.productInfoIndex.refNumberIndex != undefined ||
        this.productInfoIndex.hqTransactionNumberIndex != undefined
      )
    ) {
      this.message.push("<br>未找到<b>产品型号</b>数据");
    }
    if (this.productInfoIndex.totalNumberPcsIndex === undefined) {
      this.message.push("<br>未找到<b>产品总数量</b>数据");
    }
    // if (this.productInfoIndex.totalNumberPcsIndex === undefined) {
    //   this.message.push("<br>未找到<b>产品总数量</b>数据");
    // }
    // if (this.customsPackingIndex.netWeightIndex === undefined) {
    //   this.message.push("<br>未找到<b>主包装净重</b>数据");
    // }
    // if (this.customsPackingIndex.grossWeightIndex === undefined) {
    //   this.message.push("<br>未找到<b>主包装毛重</b>数据");
    // }
    return;
  }

  private getRealVolumeUnitData(value) {
    if (this.payload.lengthUnit === "meter") {
      return multiply(Number(value), 100, 2);
    }
    return value;
  }

  private getRealWeightUnitData(value) {
    if (this.payload.weightUnit === "g") {
      return divide(Number(value), 1000, 2);
    }
    return value;
  }

  private getRealRow(value: string): number {
    return Number(value.substring(2, 4));
  }
}

class TableHeadler {
  prop: string;
  titleGroup: string[];
  whetherMerge: boolean;
  originalLabel: string;
}

class FactoryPackingList {
  factoryName: string;
  packingType: string;
  parentCode: string;
  packingLists: PackingList[];
}

class PackingList {
  typeCode: string;
  selfCode: string;
  serialNumber: string;
  customsLength: string;
  customsWidth: string;
  customsHeight: string;
  customsNetWeight: string;
  customsGrossWeight: string;
  customsCartonNumber: string; // 主包装箱号
  customsPackingQty: string; // 主包装装箱数量
  customsPackingKey: number; // 主包装编号体积合并
  customsPackingQtyKey: number; // 主包装装箱数量合并
  customsPackingWeightKey: number; // 主包装净重合并

  cartonNumber: string;
  secondaryPackingKey: number;
  secondaryPackingSerialNumber: string; //次包装箱号
  secondaryPackingQty: string; //次包装装箱数量

  secondaryPackingLength: string;
  secondaryPackingWidth: string;
  secondaryPackingHeight: string;
  secondaryPackingNetWeight: string;
  secondaryPackingGrossWeight: string;

  productSingleNetWeight: string; // 产品单只净重
  productTotalNetWeight: string; // 产品总净重

  sn: string;
  productGuestModel: string; // 客人号码
  productHqNumber: string; // HQ号码
  hqOrJrMatch: string; // 'HQ号码'放的是华强还是嘉锐号码
  productOeNumber: string; // OE号码
  productRefNumber: string; // REF号码
  hqTransactionNumber: string; // HQ交易号码
  productTotalNumberPcs: string;
  purchaseOrderNumber: string; // 采购订单号
  settlementUnitPrice: string; // 结算单价
  remark: string; // 备注
  tagInventory: string;
  containerNumber: string

  public buildCustomsPacking(
    typeCode: string,
    selfCode: string,
    serialNumber: string,
    customsCartonNumber: string,
    customsPackingQty: string,
    customsPackingKey: number,
    customsPackingQtyKey: number,
    customsPackingWeightKey: number,
    tagInventory: string
  ) {
    this.typeCode = typeCode;
    this.selfCode = selfCode;
    this.serialNumber = serialNumber;
    this.customsCartonNumber = customsCartonNumber;
    this.customsPackingQty = customsPackingQty;
    this.customsPackingKey = customsPackingKey;
    this.customsPackingQtyKey = customsPackingQtyKey;
    this.customsPackingWeightKey = customsPackingWeightKey;
    this.tagInventory = tagInventory;
    return this;
  }

  public buildWeightAndVolume(
    customsLength: string,
    customsWidth: string,
    customsHeight: string,
    customsNetWeight: string,
    customsGrossWeight: string
  ) {
    this.customsLength = customsLength;
    this.customsWidth = customsWidth;
    this.customsHeight = customsHeight;
    this.customsNetWeight = customsNetWeight;
    this.customsGrossWeight = customsGrossWeight;
    return this;
  }

  public buildSecondaryPacking(
    cartonNumber: string,
    secondaryPackingKey: number,
    secondaryPackingSerialNumber: string,
    secondaryPackingQty: string
  ) {
    this.cartonNumber = cartonNumber;
    this.secondaryPackingKey = secondaryPackingKey;
    this.secondaryPackingSerialNumber = secondaryPackingSerialNumber;
    this.secondaryPackingQty = secondaryPackingQty;
    return this;
  }

  public buildSecondaryPackingWeightAndVolume(
    secondaryPackingLength: string,
    secondaryPackingWidth: string,
    secondaryPackingHeight: string,
    secondaryPackingNetWeight: string,
    secondaryPackingGrossWeight: string
  ) {
    this.secondaryPackingLength = secondaryPackingLength;
    this.secondaryPackingWidth = secondaryPackingWidth;
    this.secondaryPackingHeight = secondaryPackingHeight;
    this.secondaryPackingNetWeight = secondaryPackingNetWeight;
    this.secondaryPackingGrossWeight = secondaryPackingGrossWeight;
    return this;
  }

  public buildProductInfo(
    sn: string,
    productGuestModel: string,
    productHqNumber: string,
    productOeNumber: string,
    productRefNumber: string,
    hqTransactionNumber: string,
    productTotalNumberPcs: string,
    purchaseOrderNumber: string,
    settlementUnitPrice: string,
    remark: string,
    containerNumber: string,
    hqOrJrMatch: string,
  ) {
    this.sn = sn;
    this.productGuestModel = productGuestModel;
    this.productHqNumber = productHqNumber;
    this.hqOrJrMatch = hqOrJrMatch;
    this.productOeNumber = productOeNumber;
    this.productRefNumber = productRefNumber;
    this.hqTransactionNumber = hqTransactionNumber;
    this.productTotalNumberPcs = productTotalNumberPcs;
    this.purchaseOrderNumber = purchaseOrderNumber;
    this.settlementUnitPrice = settlementUnitPrice;
    this.remark = remark;
    this.containerNumber = containerNumber;
    return this;
  }

  public buildProductInfoWeight(
    productSingleNetWeight: string,
    productTotalNetWeight: string
  ) {
    this.productSingleNetWeight = productSingleNetWeight;
    this.productTotalNetWeight = productTotalNetWeight;
    return this;
  }
}

class CustomsPackingIndex {
  typeCodeIndex: number;
  selfCodeIndex: number;
  lengthIndex: number;
  widthIndex: number;
  heightIndex: number;
  netWeightIndex: number;
  grossWeightIndex: number;
  customsVolumeIndex: number;
  customsQtyIndex: number;
  serialNumberIndex: number;
  customsQuantity: number;
  tagInventory: number;
}

class SecondPackingIndex {
  lengthIndex: number;
  widthIndex: number;
  heightIndex: number;
  netWeightIndex: number;
  grossWeightIndex: number;
  cartonNumberIndex: number;
  secondaryVolumeIndex: number;
  serialNumberIndex: number;
  secondaryQty: number;
}

class ProductIndex {
  snIndex: number;
  purchaseOrderNumberIndex: number; // 采购订单号
  settlementUnitPriceIndex: number; // 结算单价
  guestModelIndex: number; //客人型号
  hqNumberIndex: number; // hq号码
  jrNumberIndex: number; // jr号码
  oeNumberIndex: number; // OE号码
  refNumberIndex: number; // REF号码
  hqTransactionNumberIndex: number; // HQ交易号码
  totalNumberPcsIndex: number; // 总数量
  netWeightIndex: number; // 单支净重
  totalNetWeightIndex: number; // 总净重
  remarkIndex: number; // 备注
  containerNumberIndex: number; // 箱封号
}
